"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const calculateBudget_1 = require("../../../Util/calculateBudget");
class CustomerCalorieBudget {
    constructor(tokenService, customerRepository) {
        this.getCalorieBudget = async (customerId) => {
            await this.tokenService.getValidToken();
            return this.customerRepository.getCalorieBudget(customerId);
        };
        this.setCalorieBudgets = async (customer, calorieBudgets, _isSecure) => {
            await this.tokenService.getValidToken();
            const budgetsToModify = calorieBudgets.map((calorieBudget) => (0, calculateBudget_1.calculateBudget)(calorieBudget));
            const { isForTrainingDays: _, ...budgetForTrainingDays } = budgetsToModify.find((budget) => budget.isForTrainingDays);
            const { isForTrainingDays, ...budgetForNonTrainingDays } = budgetsToModify.find((budget) => !budget.isForTrainingDays);
            const bundle = {
                forTrainingDay: budgetForTrainingDays,
                forNonTrainingDay: budgetForNonTrainingDays,
            };
            await this.customerRepository.setCalorieBudget(customer.id, bundle);
        };
        this.tokenService = tokenService;
        this.customerRepository = customerRepository;
    }
}
exports.default = CustomerCalorieBudget;
//# sourceMappingURL=CustomerCalorieBudget.js.map